module.exports = __webpack_public_path__ + "img/slider-1.44119ab9.jpg";